import React, { useContext, useEffect, useState } from "react";
import "./ProjectNavbar.css";
import { Link, Outlet } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import ProjectContext from "../../context/project/ProjectContext";

function Navbar() {
  const projectContext = useContext(ProjectContext);
  const { selectProject, selectedProject, projects } = projectContext;
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState();

  let location = useLocation();
  console.log("###Page Launch for:", location);

  useEffect(() => {
    console.log("###selectProject:", selectedProject);

    //eslint-disable-next-line
  }, [selectedProject]);

  const showProjectDetail = (event) => {
    event.preventDefault();
    navigate("/project/details/" + selectedProject.ID);
  };

  const showArea = (event) => {
    event.preventDefault();
    setActiveTab("Area");
    navigate("/project/areas/" + selectedProject.ID);
  };

  const showUnits = (event) => {
    event.preventDefault();
    setActiveTab("Units");
    navigate("/project/units/" + selectedProject.ID);
  };

  const showRoles = (event) => {
    event.preventDefault();
    setActiveTab("Roles");
    navigate("/project/roles/" + selectedProject.ID);
  };

  // const showWorkflow = (event) => {
  //   event.preventDefault();
  //   setActiveTab("Workflow");
  //   navigate("/project/workflow/" + selectedProject.ID);
  // };

  // const showQuickLinks = (event) => {
  //   event.preventDefault();
  //   setActiveTab("QuickLinks");
  //   navigate("/project/links/" + selectedProject.ID);
  // };

  useEffect(() => {
    setActiveTab("Details");
    return () => {
      selectProject(null);
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (location.pathname.includes("detail")) {
      setActiveTab("Details");
    } else if (location.pathname.includes("areas")) {
      setActiveTab("Areas");
    } else if (location.pathname.includes("units")) {
      setActiveTab("Units");
    } else if (location.pathname.includes("roles")) {
      setActiveTab("Roles");
      // } else if (location.pathname.includes("workflow")) {
      //   setActiveTab("Workflow");
      // } else if (location.pathname.includes("links")) {
      //   setActiveTab("QuickLinks");
    } else {
      setActiveTab("Details");
    }
    //eslint-disable-next-line
  }, [location]);

  return (
    <header>
      <nav className='navbar navbar-inverse'>
        <div className='container-fluid cfl-nav'>
          <div className='navbar-header  nav-hd'>
            {/* <div className="underline-bg"></div> */}
            <a className='navbar-brand' href='#'>
              {selectedProject && <b>{selectedProject.Name}</b>}
            </a>
            <div className='underline-bg'></div>
          </div>

          <div className='btn2'>
            <button
              id='btn1'
              className={`${activeTab === "Details" ? "activeTab" : "button"}`}
              onClick={showProjectDetail}
            >
              DETAILS
            </button>
            <button
              id='btn2'
              className={`${activeTab === "Areas" ? "activeTab" : "button"}`}
              onClick={showArea}
            >
              AREAS
            </button>
            <button
              id='btn3'
              className={`${activeTab === "Units" ? "activeTab" : "button"}`}
              onClick={showUnits}
            >
              UNITS
            </button>
            <button
              id='btn4'
              className={`${activeTab === "Roles" ? "activeTab" : "button"}`}
              onClick={showRoles}
            >
              ROLES
            </button>
            {/* <button
              id='btn5'
              className={`${activeTab === "Workflow" ? "activeTab" : "button"}`}
              onClick={showWorkflow}
            >
              WORKFLOW
  </button>*/}
            {/* <button
              id="btn5"
              className={`${
                activeTab === "QuickLinks" ? "activeTab" : "button"
              }`}
              onClick={showQuickLinks}
            >
              MAPS / REPORTS
            </button> */}
          </div>
        </div>
        <Outlet />
      </nav>
    </header>
  );
}

export default Navbar;
